<template>
  <div>
    <v-container fluid pa-0>
      <v-row class="topBar">
        <v-col class="pl-2" cols="2" align-self="center">
          <v-img
            class="ml-4"
            :src="urlImage"
            contain
            transition="scale-transition"
            max-height="114"
            max-width="150"
          ></v-img>
        </v-col>
        <v-col class="titulo_topBar" align-self="center" cols="8">
          <label>Sistema de Gestión V2.0</label>
        </v-col>
        <v-col class="d-none d-sm-flex" cols="2">
          <userInfo />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import userInfo from "./userInfo";

export default {
  data: () => ({
    urlImage: require("../../assets/imgs/logoTopBar_" +
      process.env.VUE_APP_EPA +
      ".png")
  }),
  components: {
    userInfo
  },
  mounted: function() {}
};
</script>

<style scoped>
.col {
  padding: 0 !important;
}

.topBar {
  background: #9c27b0 !important;
}

.titulo_topBar {
  text-align: center;
  font-size: 32px;
  font-weight: bold;
  color: #fff;
}
</style>